import { 
  fetch, 
  fetchCore 
} from "data/controls";
import { api } from "data/api";

import { getWPUsers } from 'data/redux/actions'


export const USER_SET_DATA = 'USER_SET_DATA'
export const userSetData = data => ({ type: USER_SET_DATA })

/*
 * GAME STATUS
 */
export const _getGameStatus = (userId, gameId) => {
  return fetch(`/game/${gameId}/${userId}/status`)
}
export const getGameStatus = (userId, gameId) => (dispatch) => {

  return _getGameStatus(userId, gameId)
    .then(game => dispatch(hydrateGameStatus(gameId, game)))
    .catch(error => {
      console.log('ERROR!!!', error)
    })
}
export const hydrateGameStatus = (gameId, status) => {
  return {
    type: 'HYDRATE_GAME_STATUS',
    payload: {
      gameId,
      status
    }
  };
}

export const markReadedAwards = (gameId, awards) => (dispatch) => {

  return dispatch({
    type: 'SETNEWAWARDS_READED',
    payload: { 
      gameId: gameId,
      awards: awards
    }
  })
}

/*
 * EVENT DATA LOAD
 */
export const userEventDataLoad = (userId, gameId, eventId, instanceId) => (dispatch, getState) => {

  const state = getState()

  const instance = instanceId || 'active'
  const usereventdataurl = `/game/${gameId}/${userId}/${eventId}/instances/${instance}`

  return fetch(usereventdataurl)
    .then(result =>
      dispatch(userEventDataLoaded({
        gameId,
        eventId,
        data: result
      }))
    )
}

export const USER_EVENT_DATA_LOADED = 'USER_EVENT_DATA_LOADED'
export const userEventDataLoaded = data => (
  {
    type: USER_EVENT_DATA_LOADED,
    payload: data
  }
)


/*
 * EVENT DATA SAVE
 */
export const userEventDataSave = (userId, gameId, eventId, instanceId, values) => (dispatch, getState) => {
  
  const params = {
      method: 'PUT',
      body: values
  }

  const instance = instanceId || 'active'

  return fetch(`/game/${gameId}/${userId}/${eventId}/instances/${instance}/data`, params)
    .then(result => {
      dispatch(userEventDataLoaded({
        gameId,
        eventId,
        data: result
      }))
    })
}

/*
 * UPDATE KPIS
 */
export const updateKpis = (userId, gameId, eventId, instanceId, values) => (dispatch, getState) => {

  const params = {
      method: 'POST',
      body: values
  }
  
  const instance = instanceId || 'active'

  return fetch(`/game/${gameId}/${userId}/${eventId}/instances/${instance}`, params)
    .then(result => {
      dispatch(userEventDataLoaded({
        gameId,
        eventId,
        data: result
      }))
    })
}

/*
 * RANKINGS
 */
export const rankingDataLoad = (userId, gameId, eventId, rankingId, instanceId, level) => (dispatch, getState) => {

  const rankingUrl = `/game/${gameId}/ranking/${eventId}/instances/${instanceId || 'active'}/${rankingId}/${level || 0}/${userId}`

  return fetch(rankingUrl)
    .then(
      result => dispatch(rankingDataLoaded({
        gameId,
        eventId,
        rankingId,
        data: result
      }))
    )
}

export const RANKING_DATA_LOADED = 'RANKING_DATA_LOADED'
export const rankingDataLoaded = data => (
  {
    type: RANKING_DATA_LOADED,
    payload: data
  }
)

export const uploadWPAvatar = (userId, blob) => (dispatch, getState) => {

  const state = getState()

  const gameids = state.games && Object.keys(state.games)

  const data = new FormData()
  data.append('file', blob)
  data.append('userid', userId)

  return window.fetch(`${api.core.url}/avatar/upload`,
    {
      method: 'POST',
      body: data
    }
  ).then(response => {

    if (response.status != 200) {

      response.text()
        .then(result => {
          throw new Error(result)
        })

    } else {

      response.text()
        .then(result => {

          if(gameids && gameids.length) {

            gameids
            .forEach(id => dispatch(getWPUsers(id)))

          }
        })
    }
  })

}

export const REDEEM_AMAZON_AWARD = 'REDEEM_AMAZON_AWARD'
export const redeemAmazonAward = (gameId, userId, awardId) => (dispatch, getState) => {

  return fetch(`/awards/redeem/${gameId}/${userId}`, {
    method: 'POST',
    body: { awardsIds: awardId }
  })
  .then(() => dispatch(getGameStatus(userId, gameId)) )
}

export const USER_CHECK_HASAVATAR = 'USER_CHECK_HASAVATAR'
export const userCheckHasavatar = (userId) => (dispatch, getState) => {

  const state = getState()

  if(state?.user?.avatarchecked) { return }

  return fetch(
    `/avatar/userhas/${userId}`,
    {},
    'core'
  )
  .then(result => dispatch(userAvatarHas(result)))
}

export const USER_AVATAR_HAS = 'USER_AVATAR_HAS'
export const userAvatarHas = has => (
  {
    type: USER_AVATAR_HAS,
    payload: has
  }
)


/*
 * GROUPS
 */
export const groupDataLoad = (userId, gameId, eventId, instanceId, groupId) => (dispatch, getState) => {

  const url = `/game/${gameId}/${userId}/${eventId}/instances/${instanceId || 'active'}/${groupId}`

  return fetch(url)
    .then(
      result => dispatch(groupDataLoaded({
        gameId,
        eventId,
        groupId,
        data: result
      }))
    )
}

export const GROUP_DATA_LOADED = 'GROUP_DATA_LOADED'
export const groupDataLoaded = data => (
  {
    type: GROUP_DATA_LOADED,
    payload: data
  }
)



/*
 * GLOBAL DATA
 */
export const getGlobalData = (gameId, playerId, queryParams) => (dispatch, getState) => {

  const params = Object.keys(queryParams)
                        .map(key => `${key}=${queryParams[key]}`)
                        .join('&')

  const url = `/globaldata/${gameId}/${playerId}?${params}`

  return fetch(url)
    .then(result => {

      console.log(result)
      return result
    })
}

export const saveGlobalData = (gameId, playerId, values, replace) => (dispatch, getState) => {

  return fetch(`/globaldata/${gameId}/${playerId}${replace ? '?replace=true' : ''}`, {
    method: 'POST',
    body: values
  })
  
}